export const DOMAIN_NAME = process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

// API endpoints
export const ENDPOINTS = {
  LOGIN: `${DOMAIN_NAME}${API_VERSION}/customertracker/dealer/login`,
  CREATE_CUSTOMER: `${DOMAIN_NAME}${API_VERSION}/customertracker/createcustomer`,
  RELATIONSHIP_MANAGERS: `${DOMAIN_NAME}${API_VERSION}/relationshipmanagers`,
  GET_CUSTOMERS_BY_DEALER_CODE: `${DOMAIN_NAME}${API_VERSION}/customertracker/getcustomersbydealercode`,
  GET_RELATIONSHIP_MANAGERS: `${DOMAIN_NAME}${API_VERSION}/customertracker/getrelationshipmanagers`,
  RESET_PASSWORD: `${DOMAIN_NAME}${API_VERSION}/customertracker/resetpassword`,
  GET_ALL_MODELS:
    `${DOMAIN_NAME}${API_VERSION}/inventory/models/getAllModels`.replace(
      "wrap",
      "rpc"
    ),
};
